import React, { FunctionComponent } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Image from '@sport1/react-elements/Image'
import { withTheme } from '@sport1/react-elements'
import { TestID } from '../../../utils/PropTypesDefinitions'
import { OddsProvider } from '..'
import { ThemeProps } from '../../../Theme/ThemeComponentTypes'
import ThemeInterface from '../../../themes/ThemeInterface'
import { isDarkTheme } from '../../../utils/ThemeHelper'
import {
    AppBwinLogo,
    AppDarkBwinLogo,
    AppHpybetLogo,
    AppInterwettenLogo,
    AppNeoBetLogo,
    AppDarkNeoBetLogo,
    AppTipicoLogo,
    AppUnibetLogo,
} from './styles/mobile'
import {
    DesktopBwinLogo,
    DesktopHpybetLogo,
    DesktopInterwettenLogo,
    DesktopNeoBetLogo,
    DesktopTipicoLogo,
    DesktopUnibetLogo,
} from './styles/desktop'
import getPlatform from './getPlatform'

export enum Platform {
    APP = 'app',
    MOBILE = 'mobile',
    DESKTOP = 'desktop',
}

export type LogoImageProps = {
    readonly source: string
    readonly width: number
    readonly height: number
}

const getLogo = (
    platform: Platform,
    provider: OddsProvider,
    theme?: ThemeInterface
): LogoImageProps => {
    if (platform === Platform.APP || platform === Platform.MOBILE) {
        switch (provider) {
            case OddsProvider.BWIN:
                return isDarkTheme(theme) ? AppDarkBwinLogo : AppBwinLogo
            case OddsProvider.HPYBET:
                return AppHpybetLogo
            case OddsProvider.INTERWETTEN:
                return AppInterwettenLogo
            case OddsProvider.TIPICO:
                return AppTipicoLogo
            case OddsProvider.UNIBET:
                return AppUnibetLogo
            case OddsProvider.NEOBET:
                return isDarkTheme(theme) ? AppDarkNeoBetLogo : AppNeoBetLogo
        }
    }

    switch (provider) {
        case OddsProvider.BWIN:
            return DesktopBwinLogo
        case OddsProvider.HPYBET:
            return DesktopHpybetLogo
        case OddsProvider.INTERWETTEN:
            return DesktopInterwettenLogo
        case OddsProvider.TIPICO:
            return DesktopTipicoLogo
        case OddsProvider.UNIBET:
            return DesktopUnibetLogo
        case OddsProvider.NEOBET:
            return DesktopNeoBetLogo
    }
}

export type LogoProps = {
    provider: OddsProvider
} & TestID &
    ThemeProps

const Logo: FunctionComponent<LogoProps> = ({ provider, theme, testID }) => {
    const platform = getPlatform()
    const logo = getLogo(platform, provider, theme)
    return (
        <Grid
            center
            noExpand
            minWidth={logo?.width ?? 60}
            maxWidth={140}
            paddingX="10px"
            testID={testID}
        >
            {logo ? <Image width={logo.width} height={logo.height} src={logo.source} /> : null}
        </Grid>
    )
}

export default withTheme(Logo)
